import type { StoreActionApi } from 'react-sweet-state';
import { fireOperationalAnalyticsWithContext } from '@atlassian/jira-ui-modifications-analytics';
import {
	screenTabsPublicToInternalTransformer,
	screenTabsPublicToInternalValidator,
} from '@atlassian/jira-ui-modifications-fields-configuration';
import type { ScreenTabsChangesPublic } from '@atlassian/jira-ui-modifications-fields-configuration/src/common/utils/common/types/screen-tabs';
import type { AppId, IssueAdjustmentsState, StoreContainerProps } from '../../types';
import {
	SCREENTAB_VALIDATION_ERROR,
	UiModificationsScreenTabsValidationError,
} from '../../utils/errors/ui-modifications-screentabs-validation-error';
import { setAppErrors } from '../app-errors';

type ProcessIframeScreenTabsChangesPayload = {
	screenTabsChanges: ScreenTabsChangesPublic;
	appId: AppId;
};

/**
 * Update screen tabs store data from changes coming from UI Modifications
 */
export const updateScreenTabs =
	({ screenTabsChanges: screenTabsFromIframe, appId }: ProcessIframeScreenTabsChangesPayload) =>
	(
		{ getState, setState, dispatch }: StoreActionApi<IssueAdjustmentsState>,
		{ viewType, createAnalyticsEvent }: StoreContainerProps,
	) => {
		const { screenTabs: internalScreenTabs } = getState();
		try {
			if (
				screenTabsFromIframe &&
				internalScreenTabs &&
				screenTabsPublicToInternalValidator(screenTabsFromIframe, internalScreenTabs)
			) {
				setState({
					screenTabs: screenTabsPublicToInternalTransformer(
						screenTabsFromIframe,
						internalScreenTabs,
					),
				});
			} else {
				throw new UiModificationsScreenTabsValidationError('Transformation failed', {
					errors: [
						{
							type: SCREENTAB_VALIDATION_ERROR,
							message: 'Transformation failed',
						},
					],
				});
			}
		} catch (err) {
			if (err instanceof UiModificationsScreenTabsValidationError) {
				fireOperationalAnalyticsWithContext(
					createAnalyticsEvent({}),
					'screenTabsChangesValidation failed',
					viewType,
					{ ...err.attributes },
				);

				// Setting app errors from validators to pass them to the onErrorCallback
				dispatch(setAppErrors({ errors: err.attributes.errors, appId }));
			}
		}
	};
